import React, { useState, useEffect, useRef } from "react"
import MetaTags from 'react-meta-tags';
import Select from "react-select"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  InputGroup,
  Input,
  Label,
  Spinner,
  Row,
  Button,
  Badge
} from "reactstrap"

import * as moment from "moment"
import classnames from "classnames"
import { Link , useHistory} from "react-router-dom"
import { useSelector, useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { setTimeCounter } from "store/products/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Loader from "components/Common/Loader"
import COADropDown from "../../components/Product/COADropDown"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { getExpenseDetails } from "helpers/backend_helper"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"

const ExpensePaymentEntry = (props) => {

  const modeOptions = [
    {
      label: "Cash",
      value: "cash"
    },{
      label: "Electronic Transfer",
      value: "etrans"
    },{
      label: "Cheque / DD",
      value: "cheque"
    }
  ]

  const history = useHistory()
  const dispatch = useDispatch()

  const [savedSuccessFully, setSavedSuccessFully] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [isEdit, setIsEdit] = useState(false)

  const [showLoading, setShowLoading] = useState(false)
  const [paymentEntry, setPaymentEntry] = useState(initialisePaymentEntry())
  const [selectedMode, setSelectedMode] = useState(null)

  const [validation, setValidation] = useState({
    receiptdate: null,
    cashpaid: null,
    mode: null,
    toaccountid: null,
    paymentaccountid: null,
  })

  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      
      getExpenseFromServer(params.id)
      
      /*
      getSalesDetails(params.id)

      const selectedSupplier = supplierList.filter(each => each.value == params.id)
      setSelectedSupplier(selectedSupplier)
      setPaymentEntry({
        ...paymentEntry,
        supplierid : params.id
      })
      */
    } 
  }, [])

  async function getExpenseFromServer(id){
    setShowLoading(true)
    const resp = await getExpenseDetails({
      inputKey:id
    })
    if(resp && resp.id){
      setIsEdit(true)
      setPaymentEntry(resp)

      const mode = modeOptions.filter(each=>each.value==resp.mode)
      if(mode.length>0){
        setSelectedMode(mode[0])
      }
    }
    setShowLoading(false)
  }
  function createNewPayment(){
    setSavedSuccessFully(false)
    setSelectedMode(null)
    setPaymentEntry(initialisePaymentEntry())
    setValidation({
      receiptdate: null,
      suppinvoiceno: null,
    })
  }

  const onBackToExpenses = () => {
    history.push('/list-expenses')
  }

  function initialisePaymentEntry(){
    return {
      receiptdate: moment(new Date()).format("yyyy-MM-DD HH:mm"),
      cashpaid: '0',
      paymentaccountid: '',
      mode: 'cash',
      toaccountid: '',
      reference: '',
      comments: '',
    }
  }

  function selectModeForAccount(fromAccount){
    if(fromAccount == 'Cash'){
      const mode = modeOptions.filter(each=>each.value=='cash')
      if(mode.length>0){
        setSelectedMode(mode[0])
      }
    }
    else {
      const mode = modeOptions.filter(each=>each.value=='etrans')
      if(mode.length>0){
        setSelectedMode(mode[0])
      }
    }
  }

  const mandatoryFields = ['receiptdate','mode','paymentaccountid','toaccountid','cashpaid']

  const onChangeValidation = (fieldName, value) => {
    if(mandatoryFields.includes(fieldName)){
      const modifiedV = { ...validation }
      if (value !== "") {
        modifiedV[fieldName] = true
      } else {
        modifiedV[fieldName] = false
      }
      setValidation(modifiedV)
    }
  }

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }


  function validateFormSubmit(){
    let formValid = true;
    const modifiedV = { ...validation }
    mandatoryFields.forEach(eachItem =>{
      if(paymentEntry[eachItem] && paymentEntry[eachItem].trim() != ""){
        modifiedV[eachItem] = true
      }
      else{
        modifiedV[eachItem] = false
        formValid = false
      }
    })

    if(paymentEntry.cashpaid != "" && Number(paymentEntry.cashpaid) <= 0){
      modifiedV['cashpaid'] = false
      formValid = false
    }

    setValidation(modifiedV)

    return formValid
  }

  function savePaymentEntry(){
    let isFormValid = validateFormSubmit()
    
    //console.log('isFormValid?:'+isFormValid)
    if(isFormValid && !isEdit){
      submitCreateNewPaymentEntry(paymentEntry)
    }
    else if(isFormValid && isEdit){
      submitEditPaymentEntry(paymentEntry)
    }
  }

  async function submitEditPaymentEntry(paymentEntryDetails) {
    setShowLoading(true)
    const response = await onEditItemDirect(paymentEntryDetails, 'ExpensePaymentEntry')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){

      setSuccessMessage('Payment Entry Edited Successfully.')
      setSavedSuccessFully(true)
      setShowSuccessPopUp(true)
      
    }
    dispatch(setTimeCounter(1500000))
    setShowLoading(false)
  }

  async function submitCreateNewPaymentEntry(paymentEntryDetails) {
    setShowLoading(true)
    const response = await onAddItemDirect(paymentEntryDetails, 'ExpensePaymentEntry')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){

      setSuccessMessage('Payment Entry added successfully.')
      setSavedSuccessFully(true)
      setShowSuccessPopUp(true)
      
    }
    dispatch(setTimeCounter(1500000))
    setShowLoading(false)
  }

  const formatDate = date => {
    return moment(new Date(date)).format("DD MMM Y")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Expense Payment Entry | Flamingo</title>
        </MetaTags>
        <Loader showLoader={showLoading} />
        <Container fluid>
          {isEdit ? 
          <Breadcrumbs title="Expense" breadcrumbItem="Edit Expense Entry" /> 
          :
          <Breadcrumbs title="Expense" breadcrumbItem="Expense Entry" />
          }
          <Row>
            <Col lg="12">
              <Card style={{minHeight :"550px"}}>
                <CardBody>
                  <Form>
                    <Row>
                      <Col lg="12">
                        <Row>
                          <Col lg="3">
                            <FormGroup className="mb-4">
                              <Label>Receipt Date</Label>
                              <InputGroup>
                                <Flatpickr
                                  id="receiptdate"
                                  className="form-control d-block"
                                  placeholder="dd MM yyyy H:i"
                                  value={paymentEntry.receiptdate}
                                  options={{
                                    enableTime: true,
                                    altInput: true,
                                    altFormat: "j M Y, H:i",
                                    dateFormat: "Y-m-d H:i",
                                  }}
                                  onChange={date => {
                                    const date1 = moment(new Date(date)).format("yyyy-MM-DD HH:mm ")
                                    setPaymentEntry({
                                      ...paymentEntry,
                                      receiptdate : date1
                                    })
                                    onChangeValidation("receiptdate", date1)
                                  }}
                                />
                                {(validation["receiptdate"] === false) &&
                                  <div className="custom-error">
                                    Please select the Receipt Date
                                  </div>
                                }
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          {isEdit && <Col className="ms-3" lg="2">
                            <FormGroup className="mb-4">
                              <Label>Receipt No.
                              </Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  disabled
                                  value={paymentEntry.id || ''}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          }
                        </Row>
                        <Row>
                          <Col lg="3">
                            <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                              <Label>
                                From Account
                              </Label>
                              <COADropDown 
                                id={paymentEntry.paymentaccountid || ''}
                                groupCode="CH,BA"
                                accountType="CASH"
                                selectOnChange={e =>{
                                  setPaymentEntry({
                                    ...paymentEntry,
                                    paymentaccountid : e.value,
                                  })
                                  selectModeForAccount(e.label)
                                  onChangeValidation("paymentaccountid", e.value)
                                }}
                                >
                              </COADropDown>
                              {(validation["paymentaccountid"] === false) &&
                                <div className="custom-error">
                                  Please select the From Account
                                </div>
                              }
                            </div>
                          </Col>
                          <Col lg="2">
                            <FormGroup className="mb-4">
                              <Label>Select Mode</Label>
                                <Select
                                  onChange={(e) => {
                                    setPaymentEntry({
                                      ...paymentEntry,
                                      mode : e.value
                                    })
                                    setSelectedMode(e)
                                    onChangeValidation("mode", e.value)
                                  }}
                                  value={selectedMode}
                                  options={modeOptions}
                                  classNamePrefix="select2-selection"
                                  isLoading={false}
                                  id="productcustomer"
                                />
                                {(validation["mode"] === false) &&
                                  <div className="custom-error">
                                    Please select the Mode
                                  </div>
                                }
                            </FormGroup>
                          </Col>
                          <Col lg="2">
                            <FormGroup className="mb-3">
                              <Label>Reference</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="reference"
                                  maxLength="30"
                                  value={paymentEntry.reference}
                                  onChange={e => {
                                    setPaymentEntry({
                                      ...paymentEntry,
                                      reference : e.target.value,
                                    })
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>

                        </Row>
                        <Row>
                          <Col lg="3">
                            <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                              <Label>
                                To Account
                              </Label>
                              <COADropDown 
                                id={paymentEntry.toaccountid || ''}
                                groupCode="EI,LA,DA"
                                accountType=""
                                selectOnChange={e =>{
                                  setPaymentEntry({
                                    ...paymentEntry,
                                    toaccountid : e.value,
                                  })
                                  onChangeValidation("toaccountid", e.value)
                                }}
                                >
                              </COADropDown>
                              {(validation["toaccountid"] === false) &&
                                <div className="custom-error">
                                  Please select the To Account
                                </div>
                              }
                            </div>
                          </Col>
                          <Col lg="2">
                            <FormGroup className="mb-3">
                              <Label>Amount Paid</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="cashpaid"
                                  maxLength="10"
                                  value={paymentEntry.cashpaid.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                  onChange={e => {
                                    if(isNumber(e.target.value) || (e.target.value== '')){
                                      let enteredVal = e.target.value
                                      if(e.target.value== ''){
                                        enteredVal = 0;
                                      }
                                      setPaymentEntry({
                                        ...paymentEntry,
                                        cashpaid : e.target.value,
                                      })
                                    }
                                    onChangeValidation("cashpaid", e.value)
                                  }}
                                />
                                {(validation["cashpaid"] === false) &&
                                  <div className="custom-error">
                                    Please enter a valid amount
                                  </div>
                                }
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="3">
                            <div className="mb-3">
                              <Label for="description">
                                Comments
                              </Label>
                              <textarea
                                id="description"
                                className="form-control"
                                rows="2"
                                maxLength="150"
                                value={paymentEntry.comments || ''}
                                onChange={e => {
                                  setPaymentEntry({
                                    ...paymentEntry,
                                    comments : e.target.value,
                                  })
                                }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div className="text-center clearfix">
                          <Button
                            color="secondary"
                            disabled={savedSuccessFully}
                            className="btn w-lg btn-info mt-3 me-2"
                            onClick={() => {
                              savePaymentEntry()
                            }}
                            >
                              SAVE
                          </Button>

                          {savedSuccessFully && 
                          <Button
                            color="primary"
                            className="btn w-lg btn-primary mt-3 me-2"
                            onClick={() => {
                              createNewPayment()
                            }}
                            >
                              <i className="bx bx-plus me-1"></i>Add New Expense
                          </Button>
                          }
                        </div>
                      </Col>
                      <Col>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
      {showSuccessPopUp ? (
        <SweetAlert
          title="Success!"
          success
          onConfirm={() => {
          }}
          customButtons={
            <>
            <Button
              color="info"
              className="btn btn-info me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                onBackToExpenses()
              }}
              >
                <i className="bx bx-printer me-1"></i>All Expenses
            </Button>

            <Button
              color="primary"
              className="btn btn-primary me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                createNewPayment()
              }}
              >
                <i className="bx bx-plus me-1"></i>New Expense
            </Button>
            
            <Button
              color="warning"
              className="btn btn-warning me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
              }}
              >
                <i className="bx bx-window-close me-1"></i>Close
            </Button>
            </>
          }
          
        >
          {successMessage}
        </SweetAlert>
      ) : null}

    </React.Fragment>
  )
}

export default ExpensePaymentEntry
